import { Col, Form, Row, Stack } from "react-bootstrap";
import { useState } from "react";
import FileUploader from "../../../../@ui/FileUploader";
import ImportTable from "../ImportTable/ImportTable";
import { useOSHighwaysService } from "../../../../hooks";

const OSHighwaysLayer = () => {
  const osHighwaysService = useOSHighwaysService();
  const [importFile, setImportFile] = useState<File | null>(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  const onUpload = () => {
    if (importFile) {
      setUploadingFile(true);
      osHighwaysService
        .Import(importFile)
        .then(() => {
          setUploadingFile(false);
        })
        .catch(() => {});
    }
  };

  const onClear = () => {
    setImportFile(null);
  };

  return (
    <>
      <Stack gap={4} className="mb-3">
        <Row>
          <Col sm={6}>
            <Row>
              <Form.Label>Upload data for new import</Form.Label>
            </Row>
            <Row>
              <FileUploader
                onClear={onClear}
                onUpload={onUpload}
                onChange={setImportFile}
                disableButtons={!importFile}
                loading={uploadingFile}
              />
            </Row>
          </Col>
        </Row>
      </Stack>
    <ImportTable />
    </>
  );
};

export default OSHighwaysLayer;
